import type { ReactNode } from 'react';
import './Hero.css';

interface HeroProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  size?: 'small' | 'medium' | 'large';
  backgroundImage?: string;
}

export function Hero({ title, subtitle, children, size = 'medium', backgroundImage }: HeroProps) {
  return (
    <section
      className={`hero hero--${size}`}
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}
    >
      <div className="hero__overlay"></div>
      <div className="container hero__content">
        <h1 className="hero__title">{title}</h1>
        {subtitle && <p className="hero__subtitle">{subtitle}</p>}
        {children && <div className="hero__actions">{children}</div>}
      </div>
    </section>
  );
}
